import * as types from 'modules/predefinedMessages/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {import('modules/global/generic.types').Page?} State */
const initialState = {
  number: 0,
  totalElements: 0,
  totalPages: 0,
  size: 10,
};

const updateState = (state, { payload }) => ({
  ...state,
  ...payload.page,
});

const resetState = () => initialState;

export default createReducer(initialState, {
  [types.FETCH_ALL_BY_DEALER_SUCCESS]: updateState,
  [types.FETCH_ALL_BY_DEALER_FAILURE]: resetState,
});
